import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useWorkspace } from '../../context/WorkspaceContext';
import Input from '../../components/Input/Input';
import Button from '../../components/Button/Button';
import SignUpLayout from './SignUpLayout';
import './SignUp.css';

const CreateTeam = () => {
  const [teamName, setTeamName] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const { user } = useAuth();
  const navigate = useNavigate();
  const { createTeam } = useWorkspace();

  // Redirect if not signed in
  useEffect(() => {
    if (!user) {
      navigate('/login');
    }
  }, [user, navigate]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    if (!teamName.trim()) {
      setError('Team name is required');
      setLoading(false);
      return;
    }

    try {
      await createTeam(teamName);
      localStorage.removeItem('isSignUp');
      navigate('/choose-plan');
    } catch (err: any) {
      setError(err.message || 'Failed to create team');
    } finally {
      setLoading(false);
    }
  };

  return (
    <SignUpLayout
      title="Create your team"
      subtitle="Teams help you collaborate with others"
      currentStep={3}
      totalSteps={4}
    >
      <form onSubmit={handleSubmit} className="signup-form">
        <div className="signup-form-fields">
          <Input
            label="Team Name"
            type="text"
            value={teamName}
            onChange={(e) => setTeamName(e.target.value)}
            placeholder="Enter your team name"
            error={error}
            sizeVariant="large"
            required
          />
        </div>
        
        <Button 
          type="submit" 
          className="signup-button"
          variant="primary"
          size="large"
          disabled={loading}
          isLoading={loading}
        >
          Complete Setup
        </Button>
      </form>
    </SignUpLayout>
  );
};

export default CreateTeam; 